export const getTooltipDataHook = (baseDataHook = 'infoicon-') =>
  `${baseDataHook}-tooltip`;
